import React from "react";
import { Link } from "react-router-dom";

export const Footer = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  function Footer(props, ref) {
    return (
      <footer ref={ref} className="border-t border-border/50 py-12 px-6" {...props}>
        <div className="max-w-5xl mx-auto w-full flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground/70 font-medium">
            © {new Date().getFullYear()} PodBrief.
          </p>
          <nav className="flex items-center gap-6">
            <Link
              to="/contact"
              className="text-xs text-foreground/70 font-medium hover:text-foreground transition-colors"
            >
              Contact
            </Link>
            <Link
              to="/explore"
              className="text-xs text-foreground/70 font-medium hover:text-foreground transition-colors"
            >
              Explore
            </Link>
            <Link
              to="/privacy"
              className="text-xs text-foreground/70 font-medium hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-foreground/70 font-medium hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <a
              href="https://blog.podbrief.io"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-foreground/70 font-medium hover:text-foreground transition-colors"
            >
              Blog
            </a>
          </nav>
        </div>
      </footer>
    );
  }
);
